module.exports = __webpack_public_path__ + "img/delivery-man.b24d21ee.svg";